import React from 'react';
import PropTypes from 'prop-types';

export default function IconCircle({ icon }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '45px',
        height: '45px',
        minHeight: '45px',
        minWidth: '45px',
        borderRadius: '50%',
        backgroundColor: '#013CDB1A',
      }}
    >
      {icon}
    </div>
  );
}

IconCircle.propTypes = {
  icon: PropTypes.node.isRequired,
};
